import { render, staticRenderFns } from "./notification-RejectedValidationFlowTaskNotification.vue?vue&type=template&id=1306d2c0&scoped=true"
import script from "./notification-RejectedValidationFlowTaskNotification.vue?vue&type=script&lang=js"
export * from "./notification-RejectedValidationFlowTaskNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1306d2c0",
  null
  
)

export default component.exports